import React, { useState, useContext } from 'react';
import { AuthContext, AuthDispatchContext } from '../context/LoginContext';
import {useLanguage} from "../context/LanguageContext";
import WCLoginService from '../services/WCLoginService';
import {SavedConfigurationsContext, SavedConfigurationsDispatch} from "../context/SavedConfigurationsContext";
import ConfigurationsService from "../services/ConfigurationsService";
import {LoaderContext, LoaderDispatch} from "../context/LoaderContext";
import SavedConfigurationList from "./SavedConfigurationList";

const LoginForm = () => {
    const {t} = useLanguage();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const { isLoggedIn, user } = useContext(AuthContext);
    const dispatch = useContext(AuthDispatchContext);
    const savedConfigurationsContext = useContext(SavedConfigurationsContext);
    const savedConfigurationsDispatch = useContext(SavedConfigurationsDispatch);
    const loaderDispatch = useContext(LoaderDispatch);

    async function updateConfigurationList() {
        const service = new ConfigurationsService();
        //get configurations list
        const saveConfigurationResponse = await service.getConfigurations();
        //console.log('saveConfigurationResponse', saveConfigurationResponse);
        //update configurations list
        savedConfigurationsDispatch({
            type: 'set',
            payload: saveConfigurationResponse
        });
    }
    const handleLogin = async (e) => {
        e.preventDefault();
        loaderDispatch({type: 'activate'});
        const response = await WCLoginService.loginCustomer(username, password);
        //console.log(response);

        if(response.token === undefined) {
            setError(response.message);

        } else {
            //login
            dispatch({ type: 'login', payload: response });
            sessionStorage.setItem('user', JSON.stringify(response));
            await updateConfigurationList();
            setSuccess(t('auth.loginSuccess'));
        }
        loaderDispatch({type: 'deactivate'});
    };
    const handleLogout = () => {
        loaderDispatch({type: 'activate'});
        dispatch({ type: 'logout' });
        setSuccess(t('auth.logoutSuccess'));
        sessionStorage.removeItem('user');
        loaderDispatch({type: 'deactivate'});
    };

    return (
        <div className="row justify-content-center">
            {isLoggedIn ? (
                <div>
                    <div style={{fontSize: "1.6rem" , marginBottom: '1rem'}}>{t('auth.welcome')} <span style={{color: "#f18914"}}> {user.user_nicename}</span></div>
                    <button style={{fontSize: "1.4rem", marginBottom: '1rem'}} className="btn btn--link" onClick={handleLogout} type="button">{t('auth.logout')}</button>
                    <SavedConfigurationList/>
                </div>
            ) : (
                <div className="col-12 col-md-8">
                    <form onSubmit={handleLogin} aria-label={t('auth.loginFormLabel')}>
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">{t('auth.username')}</label>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoComplete="username"
                                aria-required="true"
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">{t('auth.password')}</label>
                            <input
                                type="password"
                                className="form-control"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                                aria-required="true"
                            />
                        </div>
                        <div className="row">
                            <button style={{margin: "2rem auto"}} type="submit" className="btn btn--secondary">{t('auth.login')}</button>
                        </div>
                        {error &&
                            <div className="alert alert-danger mt-3" role="alert" aria-live="assertive" tabIndex={-1}
                                 dangerouslySetInnerHTML={{__html: error}}></div>}
                        {success && <div className="alert alert-success mt-3" role="status" aria-live="polite"
                                         tabIndex={-1}>{success}</div>}
                    </form>
                </div>
            )}
        </div>
    );
};

export default LoginForm;
